import { render, staticRenderFns } from "./GoogleAssistantUpdateActionButton.vue?vue&type=template&id=13120f11"
import script from "./GoogleAssistantUpdateActionButton.vue?vue&type=script&lang=ts"
export * from "./GoogleAssistantUpdateActionButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports